module.exports = __webpack_public_path__ + "static/media/copy_chatbot_script_help.a11ace24.png";